<template>
  <div>
    <b-modal
      v-model="modalShow"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <div class="m-2">
        <div class="d-flex justify-content-end">
          <img
            src="@/assets/img/cross.svg"
            alt="close"
            @click="close()"
            class="expiry-close-btn"
          />
        </div>
        <div class="mb-2 font-weight-700">
          {{ $t("refundModal.title") }}
        </div>
        <CustomInput
          :placeholder="`Wallet address for ${currency}`"
          v-model:value.trim="walletAddress"
          type="text"
        />
        <small>{{ $t("refundModal.description") }}</small>
        <div>
          <small v-if="errmsg" class="err">{{ errmsg }}</small>
        </div>
        <div class="d-flex justify-content-center mt-2 mb-2">
          <CustomButton
            :name="$t('Submit')"
            className="cs-sign-in__btn button-default w-50"
            :loader="loader"
            @handle-click="handleRefund()"
            :disabled="!walletAddress || disabled"
          />
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import CustomInput from "@/components/Input.vue";
import { CHECK_KYT, RAISE_PARTIAL_REFUND } from "@/store/modules/user/consts";
import CustomButton from "@/views/customButton.vue";
/* eslint-disable */
export default {
  name: "RefundPopup",
  props: {
    show: Boolean,
    txId: String,
    currency: String,
    receivedAmount: String,
  },
  components: {
    CustomInput,
    CustomButton,
  },
  data() {
    return {
      modalShow: false,
      walletAddress: "",
      errmsg: "",
      loader: false,
      disabled: false,
    };
  },
  watch: {
    show: {
      handler(val) {
        this.modalShow = val;
      },
    },
  },
  methods: {
    close() {
      this.$emit(`closeRefundModal`);
    },
    async handleRefund() {
      try {
        this.loader = true;
        this.errmsg = "";
        this.disabled = true;
        //check kyt
        const kytPayload = {
          walletAddress: this.walletAddress,
          currency: this.currency,
        };
        await this.$store.dispatch(`user/${CHECK_KYT}`, kytPayload);
        const refundPayload = {
          refundAddress: this.walletAddress,
          txId: this.txId,
          receivedAmount: this.receivedAmount,
        };
        await this.$store.dispatch(
          `user/${RAISE_PARTIAL_REFUND}`,
          refundPayload
        );
        this.loader = false;
        this.disabled = false;
        this.$router.push({ name: "RefundRequested" });
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.disabled = false;
        this.errmsg = e?.response?.data?.message || e?.message;
      }
    },
  },
};
</script>
<style scoped>
.expiry-close-btn {
  width: 30px;
  height: 30px;
  padding: 5px;
  cursor: pointer;
  background: none;
}

.font-weight-700 {
  font-weight: 700;
}
.err {
  color: #f53d3d;
  font-weight: 400;
}
</style>
